module.exports = __webpack_public_path__ + "img/feats-4-640.cf715dcb.jpg";